import { Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { AppMenu } from './app.menu';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [AppMenu],
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      // .layout-sidebar {
      //   background-color: var(--cnb-blue);

      //   a {
      //     margin-bottom: 3px;
      //   }

      //   a.active-route,
      //   a:hover,
      //   a:focus {
      //     background-color: var(--p-content-background) !important;

      //     .layout-menuitem-text,
      //     .layout-menuitem-icon,
      //     .layout-submenu-toggler  {
      //       color: var(--p-text-color) !important;
      //     }
      //   }
      //   .layout-submenu-toggler,
      //   .layout-menuitem-text,
      //   .layout-menuitem-icon {
      //     color:  var(--primary-contrast-color);
      //   }
      // }
    `
  ],
  template: ` <div class="layout-sidebar">
    <app-menu></app-menu>
  </div>`
})
export class AppSidebar {
  constructor(public el: ElementRef) {}
}
